import React from 'react';
import {
  CButton,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CForm,
  CRow,
  CCol,
  CInput,
  CFormText,
} from '@coreui/react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { CSpinner } from '@coreui/react';
import LoaderButton from '../components/LoaderButton';

const AddItem = ({ addModal, setAddModal, addCategory, isloading }) => {
  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Required'),
  });
  // initialize form with formik
  const { handleChange, handleSubmit, values, errors, touched } = useFormik({
    initialValues: {
      name: '',
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (value) => {
      addCategory(value.name);
    },
  });
  return (
    <CModal
      show={addModal}
      onClose={() => {
        setAddModal(false);
      }}
    >
      <CForm className="p-sm-3 p-3" onSubmit={handleSubmit}>
        <CModalHeader closeButton>Add</CModalHeader>
        <CModalBody>
          <CRow className="p-2">
            <CCol sm="12" md="12" className="xs-margin">
              <label className="text-swtich">Category</label>
              <CInput name="name" value={values.name} onChange={handleChange} />
              {errors.name && touched.name && (
                <CFormText color="danger" className="help-block">
                  {errors.name}
                </CFormText>
              )}
            </CCol>
          </CRow>
          {isloading ? (
            <div className="text-center mt-2">
              <CSpinner color="info" />
            </div>
          ) : null}
        </CModalBody>
        <CModalFooter>
          <LoaderButton title="Add" type="submit" />
          <CButton
            color="primary"
            onClick={() => {
              setAddModal(false);
            }}
          >
            Cancel
          </CButton>
        </CModalFooter>
      </CForm>
    </CModal>
  );
};

export default AddItem;
